import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { MODAL_TYPE_CHANGE_CATEGORY } from '../../constants/modal-types';
import { openModal } from '../../actions/open-modal';
import { MoveIcon } from '../../components/icons';
import MoreButton from '../../components/more-button';
import withPermissions from '../../hoc/with-permissions';
import withTranslate from '../../hoc/with-translate';

export class PostCreateActions extends Component {
  static propTypes = {
    openModal: PropTypes.func.isRequired,
    categoryId: PropTypes.string.isRequired,
    canRender: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
  }

  openModal(type) {
    return () =>
      this.props.openModal(type, {
        categoryId: this.props.categoryId,
      });
  }

  render() {
    const { canRender, t } = this.props;
    return (
      <div>
        {canRender('move', 'post', () => (
          <MoreButton onClick={this.openModal(MODAL_TYPE_CHANGE_CATEGORY)}>
            <MoveIcon/>
            {t('post-create-actions.move-post')}
          </MoreButton>
        ))}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      openModal,
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(withTranslate(withPermissions(PostCreateActions)));



// WEBPACK FOOTER //
// ./app/containers/post-create-actions/post-create-actions.js